"use strict";
exports.__esModule = true;
exports.InlineTextField = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importStar(require("react"));
var Icon_1 = require("../Icon");
var IconButton_1 = require("../IconButton");
var styles_1 = require("../styles");
var useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        withLabel: {
            '& div': {
                backgroundColor: 'transparent',
                '& fieldset': {
                    borderWidth: 0
                }
            }
        },
        sizes: function (_a) {
            var size = _a.size;
            return ({
                '& div': getSizeStyle(size)
            });
        }
    });
});
function getSizeStyle(size) {
    switch (size) {
        case 'medium':
            return {
                paddingRight: 14,
                fontSize: 16,
                height: 40,
                '& input': {
                    paddingLeft: 10
                },
                '& i': {
                    fontSize: '12px !important'
                }
            };
        case 'small':
            return {
                paddingRight: 10,
                fontSize: 14,
                height: 32,
                '& input': {
                    paddingLeft: 8
                },
                '& i': {
                    fontSize: '12px !important'
                }
            };
        case 'large':
            return {
                paddingRight: 14,
                fontSize: 16,
                height: 48,
                '& i': {
                    fontSize: '12px !important'
                }
            };
        case 'veryLarge':
            return {
                paddingRight: 16,
                fontSize: 20,
                height: 56,
                '& i': {
                    fontSize: '16px !important'
                }
            };
        case 'verySmall':
            return {
                paddingRight: 8,
                fontSize: 12,
                height: 24,
                '& input': {
                    paddingLeft: 8
                },
                '& i': {
                    fontSize: '8px !important'
                }
            };
        default:
            return {};
    }
}
function InlineTextField(props) {
    var initialValue = props.value, onChange = props.onChange, containerStyle = props.containerStyle, isLabel = props.isLabel, compact = props.compact, _a = props.inputProps, inputProps = _a === void 0 ? {} : _a, labelStyle = props.labelStyle, _b = props.clickAwayAction, clickAwayAction = _b === void 0 ? 'ABORT' : _b, _c = props.size, size = _c === void 0 ? 'medium' : _c, rest = tslib_1.__rest(props, ["value", "onChange", "containerStyle", "isLabel", "compact", "inputProps", "labelStyle", "clickAwayAction", "size"]);
    var style = inputProps.style, restinputProps = tslib_1.__rest(inputProps, ["style"]);
    var classes = useStyles(props);
    var _d = react_1.useState(false), showControls = _d[0], setShowControls = _d[1];
    var _e = react_1.useState(false), showEditingIcon = _e[0], setShowEditingIcon = _e[1];
    var _f = react_1.useState(initialValue), value = _f[0], setValue = _f[1];
    react_1.useEffect(function () {
        setValue(initialValue);
    }, [initialValue]);
    var theme = styles_1.useTheme();
    var onClickCheck = function () {
        onChange &&
            onChange({ target: { value: value } });
        setShowControls(false);
    };
    var onClickCancel = function () {
        onChange &&
            onChange({
                target: { value: initialValue }
            });
        setValue(initialValue);
        setShowControls(false);
    };
    var onFormSubmit = function (e) {
        e.preventDefault();
        setShowControls(false);
        onChange &&
            onChange({ target: { value: value } });
    };
    var handleKeyDown = function (e) {
        if (e && e.keyCode === 27) {
            onClickCancel();
        }
    };
    return (react_1["default"].createElement("form", { onSubmit: onFormSubmit, style: tslib_1.__assign({ position: 'relative', display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-end' }, containerStyle) },
        react_1["default"].createElement(core_1.TextField, tslib_1.__assign({ InputProps: {
                endAdornment: (react_1["default"].createElement(Icon_1.EIcon, { color: "secondary", name: "pencil2", style: {
                        visibility: showEditingIcon && !showControls ? 'visible' : 'hidden'
                    } }))
            }, className: classes.sizes + " " + (isLabel ? classes.withLabel : ''), inputProps: tslib_1.__assign(tslib_1.__assign({ size: compact && typeof value === 'string' ? value.length + 1 : undefined, maxLength: compact && typeof value === 'string' ? value.length + 1 : undefined }, restinputProps), { style: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, style), labelStyle), { color: showControls || showEditingIcon
                        ? theme.palette.text.primary
                        : (labelStyle === null || labelStyle === void 0 ? void 0 : labelStyle.color) || (style === null || style === void 0 ? void 0 : style.color) }) }), onBlur: function () {
                return clickAwayAction === 'ABORT' ? onClickCancel() : onClickCheck();
            }, onChange: function (e) { return setValue(e.target.value); }, onFocus: function () { return setShowControls(true); }, onKeyDown: handleKeyDown, onMouseEnter: function () { return setShowEditingIcon(true); }, onMouseLeave: function () { return setShowEditingIcon(false); }, value: value, variant: "outlined" }, rest)),
        showControls && renderControls(onClickCheck, onClickCancel)));
}
exports.InlineTextField = InlineTextField;
function renderControls(onClickCheck, onClickCancel) {
    return (react_1["default"].createElement("span", { style: { position: 'absolute', top: '100%', marginTop: 4, lineHeight: 1 } },
        react_1["default"].createElement(IconButton_1.ElevatedIconButton, { onMouseDown: onClickCheck, style: { zIndex: 999 }, variant: "rounded" },
            react_1["default"].createElement(Icon_1.EIcon, { color: "secondary", fontSize: 16, name: "check" })),
        react_1["default"].createElement(IconButton_1.ElevatedIconButton, { onMouseDown: onClickCancel, style: { marginLeft: 4, zIndex: 999 }, variant: "rounded" },
            react_1["default"].createElement(Icon_1.EIcon, { fontSize: 16, name: "x" }))));
}
//# sourceMappingURL=InlineTextField.js.map